import { Route, Switch } from 'react-router';

import { NotFoundRoute } from 'screens/NotFoundScreen';
import { ROUTE_FIRE } from 'utils/constants/routes';
import { HistoryProps } from 'utils/history';
import FireDetailScreen from './FireDetailScreen';
import FireScreen from './FireScreen';

export default ({ match }: HistoryProps) => {
  return (
    <Switch>
      <Route path={ROUTE_FIRE + '/:orgId'} component={FireScreen} exact={true} />
      <Route path={ROUTE_FIRE + '/:orgId/:fireId'} component={FireDetailScreen}/>
      <NotFoundRoute />
    </Switch>
  );
};
